module.exports = __webpack_public_path__ + "assets/img/macbook-header.c7408b61.svg";